import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { rrLogout } from "@/lib/rehearsalRoomAuth";

export default function EmptyState({ role }) {
  const navigate = useNavigate();

  async function handleLogout() {
    await rrLogout();
    navigate("/rehearsal-room/login", { replace: true });
  }

  const message =
    role === "coach_admin"
      ? "You haven't created any Workspaces yet. Your coaching workspaces will appear here."
      : "Welcome to InterAct. Your coach hasn't set up a Workspace for you yet — check back soon.";

  return (
    <section
      className="min-h-screen flex items-center justify-center bg-paper px-6"
      data-testid="rehearsal-room-empty-state"
    >
      <div className="max-w-md text-center border border-ink/15 bg-paper px-8 py-12 shadow-[4px_8px_28px_rgba(27,27,24,0.08)]">
        <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-4">InterAct Globally</p>
        <h1 className="font-serif text-3xl text-ink mb-4">Welcome to InterAct</h1>
        <p className="font-body text-ink-soft leading-relaxed mb-8" data-testid="rehearsal-room-empty-state-message">
          {message}
        </p>
        <Button variant="outline" onClick={handleLogout} data-testid="rehearsal-room-empty-state-logout">
          Log out
        </Button>
      </div>
    </section>
  );
}
